import React from 'react';
import PropTypes from 'prop-types';
import { textEllipse } from '../../../../../core/utils/text-format-helper';

import {
  RowTitleContainer,
  IconCircule,
  Name,
  Icon,
  ContainerName,
} from './styles';

const TagGroupTitle = (props) => {
  const {
    handleRowClick: onRowClick,
    isExpanded: expanded,
    name,
    countTagHighlight,
    color,
  } = props;

  return (
    <RowTitleContainer onClick={onRowClick}>
      <IconCircule name="circle" iconcolor={color} />
      <ContainerName>
        <Name>
          {`${textEllipse(name, 28)} (${countTagHighlight})`}
        </Name>
        <Icon name={expanded ? 'angle up' : 'angle down'} />
      </ContainerName>
    </RowTitleContainer>
  );
};

TagGroupTitle.propTypes = {
  name: PropTypes.string.isRequired,
  handleRowClick: PropTypes.func,
  isExpanded: PropTypes.bool,
  countTagHighlight: PropTypes.number,
  color: PropTypes.string.isRequired,
};

TagGroupTitle.defaultProps = {
  handleRowClick: () => {},
  isExpanded: false,
  countTagHighlight: 0,
};

export default TagGroupTitle;
